import React from 'react';
import { Layout } from 'antd';
import { Link } from 'react-router-dom';
import './footer.scss';

const Footer = () => null;

export default Footer;
